import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollTopService {
  private scrollTop = new BehaviorSubject<number>(null);

  public getScrollTopSubscribable(): Subject<number> {
    return this.scrollTop;
  }

  public setScrollTop(value?: number): void {
    this.scrollTop.next(value);
  }
}
